export const paths = {
    root: '/safetyNotifications',
    notifications: '/safetyNotifications/notifications',
    details: '/safetyNotifications/:safetyId',
    safetyReport: '/safetyNotifications/recipient/report',
    reporting: '/safetyNotifications/recipient/reports/:reportName',
    view: '/safetyNotifications/:safetyId/view',
};

export const navigation = {
    details: id => `/safetyNotifications/${id}`,
    viewSafetyLetter: safetyId => `/safetyNotifications/${safetyId}/view`,
    report: reportTypeSelected => `/safetyNotifications/recipient/reports/${reportTypeSelected}`
};
